import { forwardRef } from 'react';
import { Button, Tooltip, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import classnames from 'classnames';

const useStyles = makeStyles((theme) => ({
  button: {
    backgroundColor: (props) => props?.bgColor || theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    transition: theme.transitions.create('background-color'),
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: (props) =>
        props?.bgColor || theme.palette.secondary.light,
      opacity: (props) => (props?.bgColor ? 0.8 : 1),
    },
    fontWeight: 'light',
    padding: theme.spacing(0.5, 2),
    margin: theme.spacing(0.5),
    borderRadius: theme.artistActionButtons.borderRadius,
    fontSize: '1rem',
    '& span': {
      textTransform: 'initial',
      display: 'flex',
    },
  },
  buttonIcon: {
    marginRight: theme.spacing(1),
  },
  disabled: {
    backgroundColor: (props) =>
      props?.bgColor
        ? 'rgba(139, 139, 139, 1)'
        : theme.palette.secondaryAccent.extraLight,
    color: `${theme.palette.secondaryAccent.contrastText} !important`,
  },
}));

export const CallToActionPrimary = forwardRef((props, ref) => {
  const classes = useStyles({ bgColor: props?.bgColor });

  const extraClasses = Array.isArray(props.classes)
    ? props.classes
    : [props.classes];

  return (
    <Tooltip title={!props.disabled && props?.title ? props?.title : ''}>
      <Button
        ref={props.forwardedRef}
        classes={{ disabled: classes.disabled }}
        className={classnames(classes.button, ...extraClasses)}
        onClick={(e) => props.onClickHandler?.(e)}
        disabled={props.disabled}
        fullWidth={props.fullWidth}
        onBlur={(e) => props.onBlur?.(e)}
      >
        <Typography variant='button'>
          {props.icon && props.icon(classes.buttonIcon)}
          {props.label}
        </Typography>
      </Button>
    </Tooltip>
  );
});
